namespace('compass.group');

compass.group.ListLoaderProcessingWidget = compass.defineWidget(function ListLoaderProcessingWidget(options) {
     var me = this;
     var $j = jQuery;
     var d = jQuery.dom;
     var _settings = options;
     var totalReservations;
     var processedReservations;
     var spinner;
     var spinnerContainer;

     var _drawHeader = function() {
          var header = d.div({ className: 'header'}, _settings.labels.headerText);
          var groupName = d.div({ className: 'groupName'}, _settings.groupName);
          return [header, groupName];
     };

     var _drawProgress = function() {
          processedReservations = 0;
          totalReservations = _settings.numReservations;
          spinnerContainer = d.div({ className: 'spinnerContainer'});
          var submissionProgress = d.div({ className: 'submissionProgress'}, "Submitting ", d.span({ className: 'processedReservations'}, processedReservations), "/", d.span({ className: 'totalReservations'}, totalReservations), " Reservations");
          return [spinnerContainer, submissionProgress];
     };

     var _drawButtons = function() {
          var downloadButton = d.button({className: 'downloadButton button', type: 'submit'}, _settings.labels.downloadButtonText).activate(function() {
               me.trigger('ListLoaderWidget.GA', {action: 'Download Finish Page'});
               var button = me.find('.downloadButton');
               var buttonText = _settings.labels.downloadButtonText;
               me.trigger('ListLoaderWidget.DownloadRoster', {button: button, buttonText: buttonText});
          });

          var finishButton = d.button({ className: 'finishButton button'}, _settings.labels.finishButtonText).activate(function() {
               window.location.reload();
          });

          return [downloadButton, finishButton];
     };

     var _drawErrorButton = function() {
          var errorButton = d.input({ className: 'errorButton secondaryButton', value: _settings.labels.errorButtonText}).activate(function() {
               window.location.reload();
          });
          return errorButton;
     };

     var _finishProcessing = function() {
          compass.loading.stop();
          var congratulations = d.div({ className: 'congratulations'}, _settings.labels.congratulationsText);
          me.find('.submissionProgress').after(congratulations, _drawButtons());
     };

     var _drawWidget = function() {
          return _drawHeader().concat(_drawProgress());
     };

     me.bind('ListLoaderProcessingWidget.updateProcessedReservations', function(event, data) {
          processedReservations = data.processed.toString();
          totalReservations = data.total.toString();
          me.find('.processedReservations').html(processedReservations);
          me.find('.totalReservations').html(totalReservations);
     });

     me.bind('ListLoaderProcessingWidget.finishProcessing', function() {
          _finishProcessing();
     });

     me.bind('ListLoaderProcessingWidget.errorProcessing', function() {
          compass.loading.stop();
          var errorMessage = d.div({ className: 'errorMessage'}, _settings.labels.errorMessageText);
          me.find('.submissionProgress').after(errorMessage, _drawErrorButton());
     });

     me.render = function(widgetElem) {
          me.trigger('ListLoaderSubmissionResultsWidget.ProcessListMember', _settings.rosterID);
          widgetElem.append(_drawWidget());
          me.trigger('Dialog.removeCloseButton');
          compass.loading.start(spinnerContainer, {top: "-61px"});
     };
}, {
     labels: {
          headerText: 'Group Roster',
          errorMessageText: "We're Sorry. There was an error submitting your reservation updates. Please try again. You will need to download a new Group Roster.",
          errorButtonText: 'OK',
          congratulationsText: 'Congratulations! Your updates have been made. Downloading a new Group Roster will provide you with the most up-to-date reservation information.',
          downloadButtonText: 'Download Roster',
          finishButtonText: 'Finish'
     },
     WUID: 'LISTLOADERPROCESSINGWIDGET',
     widgetName: 'ListLoaderProcessingWidget'
});